<title>{{ iagPortalHowDoIServiceABookingPage.htmlTitle }}</title>
<div class="container" width="100%">
  <app-section [sections]="iagPortalHowDoIServiceABookingPage.aboveDisabilitiesSection" [isIAGPortalDocumentationPage]="true"></app-section>
  <div id="disabilitySupport">
    <div *ngFor="let section of iagPortalHowDoIServiceABookingPage.disabilitiesSection ; let i = index">
      <h4>{{ section.title }}</h4>
      <div [innerHTML]="section.body | mdToHtml"></div>
      <div class="accordion card mb-5 mt-5" id="accordionExample" *ngFor="let section of iagPortalHowDoIServiceABookingPage.disabilityMenuDescriptionsClickHere">
       
     
          <div class="card-header" (click)="toggleCollapsed(i)">
            <a [ngClass]="getActiveStyle(i)">{{ section.title }}</a>
          </div>
          <div [ngClass]="getAccordionStyle(i)" class="card-body">
            <div [innerHTML]="section.body | mdToHtml"></div>
          </div>
       
        <div [innerHTML]="section.subBody! | mdToHtml"></div>
      </div>
        </div>
  </div>
  <app-section [sections]="iagPortalHowDoIServiceABookingPage.belowDisabilitiesSection" [isIAGPortalDocumentationPage]="true"></app-section>
</div>